import { useEffect, useState, type ReactElement } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export function PaymentReturn(): ReactElement {
  const [params] = useSearchParams()
  const orderId = params.get('orderId')
  const mock = params.get('mock') === '1'
  const [closeIn, setCloseIn] = useState(5)

  useEffect(() => {
    if (closeIn <= 0) return
    const t = setTimeout(() => {
      setCloseIn(closeIn - 1)
    }, 1000)
    return () => {
      clearTimeout(t)
    }
  }, [closeIn])

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-4 py-8 text-center">
          <div className="font-display text-3xl text-primary">MyPivot</div>
          <div className="text-accent text-4xl">✓</div>
          <h1 className="font-display text-2xl">Paiement enregistré</h1>
          <p className="text-sm text-muted-foreground">
            {mock
              ? 'Mode développement : retour simulé du portail FAM.'
              : 'Vous pouvez fermer cet onglet, votre commande est en cours de traitement.'}
          </p>
          {orderId && (
            <Button className="w-full">
              <Link to={`/client/orders/${orderId}`}>Voir ma commande</Link>
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
